exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reviews__spinner[data-v-4400b226],.reviews__wrap[data-v-4400b226]{margin:auto}.reviews__text[data-v-4400b226],.reviews__wrap[data-v-4400b226]{text-align:center}.reviews__list[data-v-4400b226]{margin-bottom:33px!important;border-bottom:1px solid #d3d4d9}.reviews__panel[data-v-4400b226]{margin-bottom:55px;padding:0}.reviews__message[data-v-4400b226]{height:370px;display:-ms-flexbox;display:flex}.reviews__spinner[data-v-4400b226]{width:100px;height:100px;display:block}.reviews__subheader[data-v-4400b226]{margin-bottom:9px}.reviews__text[data-v-4400b226]{margin:0 auto -18px;width:40%;font-size:14px;line-height:1.42;color:#666}.reviews__btn[data-v-4400b226]{margin:40px auto 0;max-width:300px}.error[data-v-4400b226]{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4400b226","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/parts/reviews/Reviews.vue
// module id = 89d92ff5b2d1e8ff6674
// module chunks = 0